import { useEffect, useState } from "react";

import { ExperienceType } from "../../gql-generated/types";

import { useExperienceDismissalService } from "./useExperienceDismissalService";

const useFeedbackRatingDismissalService = () => {
    const undismissedExperiences = useExperienceDismissalService([ExperienceType.FeedbackRating]);
    return undismissedExperiences.has(ExperienceType.FeedbackRating);
};

export const useFeedbackRatingShowService = (): { show: boolean; setShow: (show: boolean) => void } => {
    const [show, setShow] = useState(false);
    const dismissedInService = useFeedbackRatingDismissalService();

    useEffect(() => {
        if (dismissedInService) {
            setShow(dismissedInService);
        }
    }, [dismissedInService]);

    return { show, setShow };
};
